/** Filter cardholder name to allow only letters, spaces, hyphens, apostrophes, periods, and commas */
export const CARDHOLDER_NAME_INPUT_FILTER_REPLACE_REGEX = /[^a-zA-Z\s'.,-]/g

/** 驗證信用卡持卡人姓名 */
const CARDHOLDER_NAME_REGEX = /^[a-zA-Z\s'.,-]+$/
export const isCardholderName = (name: string) => CARDHOLDER_NAME_REGEX.test(name)

/** 過濾持卡人姓名輸入，只允許英文字母、空格、連字號、撇號、句號和逗號，並轉為大寫 */
export const filterCardholderName = (value: string) =>
  value.replace(CARDHOLDER_NAME_INPUT_FILTER_REPLACE_REGEX, '').toUpperCase()
